/* eslint-disable no-unused-vars */
import { Suspense } from "react";
import { Outlet, Navigate } from "react-router-dom";
import Layout from "../../components/layout";
import SplashLoader from "../../components/ui/loader";
import { useAuth } from "../../controllers/auth";

const ProtectedRoutes = () => {
  // const user = useCurrentuser();
  const { authenticated, session } = useAuth();
  return authenticated ? (
    <Suspense fallback={<SplashLoader />}>
      <Layout>
        <Outlet />
      </Layout>
    </Suspense>
  ) : (
    <Navigate to={`/`} />
  );
};

export default ProtectedRoutes;
